import { ProductsConfig } from '../../../interfaces/mock.interface';

export const PLANS_MOCK: ProductsConfig[] = [
    {
        label: 'B&You 100Go',
        gencode: '6712',
    },
    {
        label: 'B&You 50Go',
        gencode: '6305',
    },
    {
        label: '5GO SIMO - BLoquable',
        gencode: '6897'
    },
    {
        label: '130Go 5G SIM Seule',
        gencode: '6850',
    },
    {
        label: '200Go 5G SIM Seule',
        gencode: '6852',
    },
    {
        label: '200Go Seule Smartchange',
        gencode: '6969',
    },
    {
        label: '150Go 5G av. smartphone',
        gencode: '6848',
    },
      {
        label: '300Go Av. smartphone',
        gencode: '6876',
    },
    {
        label: '300Go Seule Smartchange',
        gencode: '6970',
    },
  
];
